import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {AlertInstanceModel} from "../_models/AlertInstanceModel";
import {AppEvent} from "../../../event-buses/AppEvent";

export const IT_ALERT_INSTANCE_CONTROLLER = new InjectionToken<IAlertInstanceController>('IT_ALERT_INSTANCE_CONTROLLER');
export const MK_ALERT_INSTANCE = new ModelKey<AlertInstanceModel>('MK_ALERT_INSTANCE');

export interface IAlertInstanceController extends IController {

  handleInit(eventData: any): void;
  handleAlertSelection(eventData: any): void;

  onNotificationListToggled(event: AppEvent): void;
}
